export const theme = {
  colors: {
    ink: "var(--ink)",
    ink2: "var(--ink-2)",
    ink3: "var(--ink-3)",
    ink4: "var(--ink-4)",

    surface: "var(--surface)",
    surface2: "var(--surface-2)",

    accent: "var(--accent)",
    accent2: "var(--accent-2)",
    accent3: "var(--accent-3)",
    green: "var(--green)",
    amber: "var(--amber)",
    red: "var(--red)",
    purple: "var(--purple)",
  },

  fonts: {
    sans: "var(--font-sans)",
    heading: "var(--font-heading)",
    mono: "var(--font-mono)",
  },

  radius: {
    sm: "var(--radius-sm)",
    md: "var(--radius-md)",
    lg: "var(--radius-lg)",
  },

  shadows: {
    sm: "var(--shadow-sm)",
    md: "var(--shadow-md)",
    lg: "var(--shadow-lg)",
  },
};